module.exports = __webpack_public_path__ + "static/img/小程序-小程序设计.9a0f95a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/goods/CPK10007/小程序-小程序设计.png
// module id = IMpu
// module chunks = 1